import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import App from './component/container/App';
import { ToastProvider } from 'react-toast-notifications';
import reportWebVitals from './reportWebVitals';
import Dashboard from './component/admin/Container/Dashboard';
import Register from './component/admin/Register';
import Login from './component/admin/Login';
import ProtectedRoute from './component/admin/Container/ProtectedRoute';
import ChangePassword from './component/admin/ChangePassword';


ReactDOM.render(
  <ToastProvider autoDismissTimeout={6000}>
    <BrowserRouter>
      <Switch>
        <Route path='/change-password' exact component={ChangePassword} />
        <Route path='/register' exact component={Register} />
        <Route path='/login' exact component={Login} />
        <ProtectedRoute path='/dashboard'  component={Dashboard} />
        <Route path='/'  component={App} />
      </Switch>
    </BrowserRouter>,
   </ToastProvider>,
  document.getElementById('root')
);
reportWebVitals();
